module.exports = __webpack_public_path__ + "static/img/model-bg16.e5f4c68.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg16.jpeg
// module id = Mxe3
// module chunks = 0